// extracted by mini-css-extract-plugin
export default {"titlePage":"Va5awuMQ3bbvxbEI2cQD","inner":"wcYQuy54YVk6xDzytgQU","image":"ipBf0W7viEDHlzelIElb","title":"DSHJq1nzxRYC2bQa0TMI"};